import React from 'react';
import {
  TableChart,
  LayoutGallery,
  LayoutThreeRows,
} from '@wix/wix-ui-icons-common/lazy';
import { TranslationsKeys } from '@wix/bex-core';
import { ViewType } from '../../state/ViewTypeState';

export const layoutConfig: Record<
  ViewType,
  { icon: React.ReactNode; translationKey: TranslationsKeys }
> = {
  table: {
    icon: <LayoutThreeRows />,
    translationKey: 'cairo.table.layout.table',
  },
  grid: {
    icon: <LayoutGallery />,
    translationKey: 'cairo.table.layout.grid',
  },
  spreadsheet: {
    icon: <TableChart />,
    translationKey: 'cairo.table.layout.spreadsheet' as TranslationsKeys,
  },
};
